<template>
  <div class="browser-session-modal">
    <div class="browser-session-header">
      <div class="header-icon">
        <el-icon>
          <Monitor/>
        </el-icon>
      </div>
      <h6 class="header-title__modal">
        Резервный доступ
      </h6>
    </div>

    <div class="browser-session-content">
      <div class="session-data">
        <div v-for="(value, key, index) in filterInitData" :key="key + '-' +index" class="session-data-item">
          <span class="item-title">{{ key }}:</span>
          <span>{{ value }}</span>
        </div>
      </div>
    </div>
    <div class="browser-session-footer">
      <p-button
        v-loading="loading"
        type="info"
        :disabled="loading"
        @click="handleCreateBtnClick">
        Создать браузерную сессию
      </p-button>
      <p v-if="successSession" class="browser-session-success">
        Браузерная сессия успешно создана
      </p>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
  name: 'BrowserSessionModal',
  data: () => ({
    loading: false,
    successSession: false
  }),
  computed: {
    ...mapGetters(['selectedApplication']),
    filterInitData() {
      const requireFields = [
        {title: 'Email',
          alias: 'email'},
        {title: 'Коды доступа',
          alias: 'codes'},
        {title: 'Логин',
          alias: 'login'},
        {title: 'Пароль',
          alias: 'password'}]
      return requireFields.reduce((prev, item) => {
        const sharingData = this.selectedApplication.sharing_google_account[item.alias]
        let value = Array.isArray(sharingData)
          ? sharingData.join(',')
          : sharingData
        prev[item.title] = item.alias === 'login'
          ? this.selectedApplication.sharing_google_account.email
          : value
        return prev
      }, {})
    }
  },
  methods: {
    ...mapMutations(['setSelectedApplication']),
    ...mapActions({
      startBrowserSession: 'app_manager/startBrowserSession'
    }),
    async handleCreateBtnClick() {
      this.successSession = false
      this.loading = true
      const success = await this.startBrowserSession(this.selectedApplication.sharing_google_account.id)
      this.loading = false
      if (success) this.successSession = true
    }
  },
  beforeUnmount() {
    this.setSelectedApplication(undefined)
  }
}
</script>

<style scoped>

</style>
